import { Outlet } from "react-router-dom";

export function ContentStudioLayout() {
  return <Outlet />;
}
